"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeedbackReportClosed = exports.feedbackReportStatus = exports.FEEDBACK_REPORT_SHOTS_MAX = exports.FEEDBACK_REPORT_TAG_PATTERN = exports.FEEDBACK_REPORT_TAG_MAX_LENGTH = exports.FEEDBACK_REPORT_TAGS_MAX = exports.FEEDBACK_REPORT_COMMENT_MAX_LENGTH = exports.FEEDBACK_REPORT_PRIORITIES = exports.FEEDBACK_REPORT_LEGACY_STATUSES = exports.FEEDBACK_REPORT_RELEASING_STATUSES = exports.FEEDBACK_REPORT_CLOSED_STATUSES = exports.FEEDBACK_REPORT_STATUSES = void 0;
// Boards V2 beta feedback's lifecycle (ADR 0042), shared by the callable and the Feedback admin
// page. restServer's feedback service (apiv2/feedback_service.py), which makes every change,
// repeats these lists: keep them in step.
// In the order a report moves through them.
exports.FEEDBACK_REPORT_STATUSES = [
    'new',
    'triaged',
    'needs_human',
    'ready_for_agent',
    'in_progress',
    'in_pr',
    'qa_test',
    'done',
    'wontfix',
    'duplicate',
];
// A report in one of these is closed: nobody holds it, and closedAt says when it closed (moving
// between them keeps it). done is its fix checked (or shipped with nothing to check); wontfix and
// duplicate close it without one. Nothing deletes it: the page's default view leaves it out.
exports.FEEDBACK_REPORT_CLOSED_STATUSES = ['done', 'wontfix', 'duplicate'];
// Moving a report here lets go of whoever held it: the work is in a pull request, or past it.
exports.FEEDBACK_REPORT_RELEASING_STATUSES = ['in_pr', 'qa_test', 'done', 'wontfix', 'duplicate'];
// What each id written before ADR 0042 reads as. Reports are migrated; status lines keep the ids
// they were written with.
exports.FEEDBACK_REPORT_LEGACY_STATUSES = {
    needs_info: 'needs_human',
    approved: 'ready_for_agent',
    progress: 'in_progress',
    fixed: 'in_pr',
    merged: 'in_pr',
    deployed: 'qa_test',
};
exports.FEEDBACK_REPORT_PRIORITIES = ['p0', 'p1', 'p2', 'p3'];
// A comment's body, and a status change's note, at most.
exports.FEEDBACK_REPORT_COMMENT_MAX_LENGTH = 4000;
// Tags: at most this many on a report, each at most this long, compared without case.
exports.FEEDBACK_REPORT_TAGS_MAX = 20;
exports.FEEDBACK_REPORT_TAG_MAX_LENGTH = 40;
// Letters, digits, spaces and a little punctuation, starting with a letter or digit.
exports.FEEDBACK_REPORT_TAG_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 ._:/+#&'-]*$/;
// Screenshots on a report or a comment, at most.
exports.FEEDBACK_REPORT_SHOTS_MAX = 6;
// A status in today's ids: one written before ADR 0042 reads as the status it became.
const feedbackReportStatus = (status) => {
    if (!status)
        return null;
    if (status in exports.FEEDBACK_REPORT_LEGACY_STATUSES)
        return exports.FEEDBACK_REPORT_LEGACY_STATUSES[status];
    return exports.FEEDBACK_REPORT_STATUSES.includes(status) ? status : null;
};
exports.feedbackReportStatus = feedbackReportStatus;
const isFeedbackReportClosed = (status) => {
    const current = (0, exports.feedbackReportStatus)(status);
    return !!current && exports.FEEDBACK_REPORT_CLOSED_STATUSES.includes(current);
};
exports.isFeedbackReportClosed = isFeedbackReportClosed;
